import renderMarkdown from "./renderMarkdown";

function copyHtmlFallback(html: string): void {
  const div = document.createElement("div");
  div.innerHTML = html;
  div.style.cssText = "position:fixed;left:-9999px;top:0";
  document.body.appendChild(div);

  const selection = window.getSelection();
  selection?.selectAllChildren(div);
  document.execCommand("copy");
  selection?.removeAllRanges();

  document.body.removeChild(div);
}

export default async function copyMarkdown(markdown: string): Promise<void> {
  const html = renderMarkdown(markdown, { elements: "gallery" });

  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        "text/plain": new Blob([markdown], { type: "text/plain" }),
        "text/html": new Blob([html], { type: "text/html" }),
      }),
    ]);
  } catch {
    copyHtmlFallback(html);
  }
}
